<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="3" class="pr-2" v-show="filtersVisible">
                <FiltersCard />
            </v-col>

            <v-col :cols="filtersVisible ? 9 : 12">
                <ChartRow v-if="firstLoadingDone" />
                <TimelineChartRow v-if="firstLoadingDone" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import FiltersCard from "./sections/filters-card.vue";
import ChartRow from "@/pages/production-analysis/sections/chart-row.vue";
import TimelineChartRow from "@/pages/production-analysis/sections/timeline-chart-row.vue";

export default {
    name: "production-analysis-view",
    components: {
        ChartRow,
        FiltersCard,
        TimelineChartRow
    },
    watch: {
        filtersVisible() {
            this.$nextTick(() => {
                if (this.$refs.chart) {
                    this.$refs.chart.chart.reflow();
                }
            });
        },
    },
    data() {
        return {
            dataSectionColsCount: 9,
            buttonPositionLeft: "23.8%",
        };
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        ...mapActions("ProductionAnalysisStore", ["fetchData"]),
        ...mapMutations("ProductionAnalysisStore", ["toggleFilterVisible"]),
        handleKeyboardListener(e) {
            if (e.keyCode === 27 || e.key === "Escape") this.toggleFilterVisibility();
            if (document.activeElement.tagName !== "INPUT" && (e.keyCode === 13 || e.key === "Enter")) {
                if (this.filters.periodRange && this.datesChanged) {
                    this.fetchData();
                }
            }
        },
        toggleFilterVisibility() {
            this.toggleFilterVisible();

            if (!this.filtersVisible) {
                this.buttonPositionLeft = "2px";
                this.dataSectionColsCount = 12;
            } else {
                this.dataSectionColsCount = 9;
                this.buttonPositionLeft = "23.8%";
            }
        },
    },
    computed: {
        ...mapState("ProductionAnalysisStore", ["filtersVisible", "datesChanged", "filters", "firstLoadingDone"]),
    },
};
</script>

<style scoped></style>
